import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-page',
  standalone: true,
  imports: [],
  templateUrl: './page.component.html',
  styleUrl: './page.component.scss',
  host: {
    '[style.padding]': 'paddings',
    '[class]': `'content-container bg-gradient-to-b from-white from-25% to-85% to-gray-lighten block'`,
  },
})
export class PageComponent {
  @Input() padding: string = '40px 40px 40px 40px';
  get paddings(): string {
    return this.padding;
  }
}
